import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-3 rounded-lg border border-red-200 bg-red-50 p-3 text-sm font-medium text-red-700",
  role: "alert"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.message)
    ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString($props.message), 1 /* TEXT */))
    : _createCommentVNode("v-if", true)
}